import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { pure } from 'recompose';
import { CSearchProffitList } from '@/components/modules/pages/consultantSearch/List/CSearchProffitList';
import { CSearchProffitListItem, CSearchProffitListItemSkeleton, } from '@/components/modules/pages/consultantSearch/List/CSearchProffitListItem';
import { useArrayWithIndex } from '@/hooks/array/useArrayWithIndex';
import { propBool, propFunc, propShape, } from '../../../../helpers/custom-prop-types';
const ConsultantSearchSlide = pure((props) => {
    const { isShow, onClickSlide, onClickSlideClip, slideFavoriteMap, slidePage: { initialLoaded, list }, } = props;
    const className = `search_list_block_all search_slide_block_list ${isShow ? '' : 'is-dnone'}`;
    const dummies = useArrayWithIndex(6);
    if (!initialLoaded) {
        return (_jsx("div", Object.assign({ className: className }, { children: _jsx(CSearchProffitList, Object.assign({ className: 'w-full' }, { children: dummies.map(({ index }) => (_jsx(CSearchProffitListItemSkeleton, { className: 'search_slide_block' }, index))) })) })));
    }
    return (_jsx("div", Object.assign({ className: className }, { children: _jsx(CSearchProffitList, Object.assign({ className: 'w-full' }, { children: list.map((slide, index) => (_jsx("div", Object.assign({ className: 'search_slide_block', "data-value": index + 1, onClick: onClickSlide, role: 'presentation' }, { children: _jsx(CSearchProffitListItem, { image: slide.image, isClipped: slideFavoriteMap[slide.slidePageId] === undefined
                        ? slide.hasFavorite
                        : slideFavoriteMap[slide.slidePageId], onClickSlideClip: onClickSlideClip, slidePageId: slide.slidePageId, title: slide.title }) }), slide.id))) })) })));
});
ConsultantSearchSlide.propTypes = {
    isShow: propBool().isRequired,
    onClickSlide: propFunc().isRequired,
    onClickSlideClip: propFunc().isRequired,
    slideFavoriteMap: propShape().isRequired,
    slidePage: propShape().isRequired,
};
export default ConsultantSearchSlide;
